export default "__VITE_ASSET__31850e47__"